'use client';

import { useTranslations } from 'next-intl';
import { Header } from '@/components/design/layout/Header';
import { Footer } from '@/components/design/layout/Footer';
import { LegalDocumentsBlock } from '@/components/design/shared/LegalDocumentsBlock';

export function LegalPage() {
  const t = useTranslations('strings.legalPage');

  return (
    <div className="flex min-h-0 flex-1 flex-col bg-fest-surface pt-16 md:pt-20">
      <Header />

      <div className="mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col px-4 py-12 sm:px-6">
        <div className="mb-12 text-center">
          <h1
            className="mb-4 text-4xl font-bold text-fest-ink md:text-5xl"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {t('title')}
          </h1>
          <p className="text-lg text-fest-muted-text">{t('subtitle')}</p>
        </div>

        <LegalDocumentsBlock />
      </div>

      <Footer />
    </div>
  );
}
